 <template>
  <VCard class="detail-payment-wrapper">
    <VBlock :padding="[0, 15, 10, 15]" :direction="Direction.column">
      <VBlock :sort="Sort.space_between" :margin="[0, 0, 10, 0]">
        <VSpan text="주문금액" :size="16" :weight="TextWeight.bold" :spacing="-0.38" />
        <VSpan
          :text="`${orderAmount || 0}원`"
          :type="TextType.Number"
          :size="16"
          :weight="TextWeight.bold"
          :spacing="-0.38"
        />
      </VBlock>

      <VBlock v-if="showDeliveryTip" :sort="Sort.space_between" :margin="[0, 0, 10, 0]">
        <VSpan text="배달팁" :size="16" :weight="TextWeight.bold" :spacing="-0.38" />
        <VSpan
          :text="`${deliveryTip || 0}원`"
          :type="TextType.Number"
          :size="16"
          :weight="TextWeight.bold"
          :spacing="-0.38"
        />
      </VBlock>

      <VBlock v-if="showDiscountAmount" :sort="Sort.space_between" :margin="[0, 0, 10, 0]">
        <VSpan text="할인금액" :size="16" :weight="TextWeight.bold" :spacing="-0.38" />
        <VSpan
          :text="`-${discountAmount || 0}원`"
          :type="TextType.Number"
          :size="16"
          :weight="TextWeight.bold"
          :spacing="-0.38"
        />
      </VBlock>

      <VBlock v-if="showOrderDetailDiscounts" :margin="[0, 0, 15, 0]" :direction="Direction.column">
        <!-- v-for="(discount, index) in orderDetailDiscounts"
        :key="index"-->
        <VBlock
          v-if="showBaeminGiftCardDiscountAmount"
          :sort="Sort.space_between"
          :margin="[0, 0, 4, 0]"
        >
          <VBlock class="detail-discounts">
            <VBullet class="bullet" />
            <!-- <VSpan class="text" :text="discount.description" :size="14" :color="TextColor.gray2" /> -->
            <VSpan class="text" text="상품권" :size="14" :color="TextColor.gray2" />
          </VBlock>
          <VSpan
            :text="`-${baeminGiftCardDiscountAmount || 0}원`"
            :type="TextType.Number"
            :size="14"
            :color="TextColor.gray2"
          />
        </VBlock>
        <VBlock v-if="couponDiscountAmount !== 0" :sort="Sort.space_between" :margin="[0, 0, 4, 0]">
          <VBlock class="detail-discounts">
            <VBullet class="bullet" />
            <!-- <VSpan class="text" :text="discount.description" :size="14" :color="TextColor.gray2" /> -->
            <VSpan class="text" text="배달팁 할인쿠폰" :size="14" :color="TextColor.gray2" />
          </VBlock>
          <VSpan
            :text="`-${couponDiscountAmount || 0}원`"
            :type="TextType.Number"
            :size="14"
            :color="TextColor.gray2"
          />
        </VBlock>
        <VBlock v-if="orderDiscountAmount !== 0" :sort="Sort.space_between" :margin="[0, 0, 4, 0]">
          <VBlock class="detail-discounts">
            <VBullet class="bullet" />
            <!-- <VSpan class="text" :text="discount.description" :size="14" :color="TextColor.gray2" /> -->
            <VSpan class="text" text="주문금액 할인쿠폰" :size="14" :color="TextColor.gray2" />
          </VBlock>
          <VSpan
            :text="`-${orderDiscountAmount || 0}원`"
            :type="TextType.Number"
            :size="14"
            :color="TextColor.gray2"
          />
        </VBlock>
        <VBlock
          v-if="showBaeminPointDiscountAmount"
          :sort="Sort.space_between"
          :margin="[0, 0, 4, 0]"
        >
          <VBlock class="detail-discounts">
            <VBullet class="bullet" />
            <!-- <VSpan class="text" :text="discount.description" :size="14" :color="TextColor.gray2" /> -->
            <VSpan class="text" text="배민포인트" :size="14" :color="TextColor.gray2" />
          </VBlock>
          <VSpan
            :text="`-${baeminPointDiscountAmount || 0}원`"
            :type="TextType.Number"
            :size="14"
            :color="TextColor.gray2"
          />
        </VBlock>
      </VBlock>

      <div class="line"></div>

      <VBlock :sort="Sort.space_between" :margin="[0, 0, 15, 0]">
        <VSpan text="총 결제금액" :size="20" :weight="TextWeight.bold" :spacing="-0.38" />
        <VSpan
          :text="`${orderDetailPayment.paymentAmount || 0}원`"
          :type="TextType.Number"
          :size="20"
          :weight="TextWeight.bold"
          :spacing="-0.38"
        />
      </VBlock>
      <VBlock v-if="showPaymentMethod" :sort="Sort.space_between" :margin="[0, 0, 15, 0]">
        <VSpan text="결제방법" :size="20" :weight="TextWeight.bold" :spacing="-0.38" />
        <VSpan
          :text="orderDetailPayment.method || ''"
          :type="TextType.Number"
          :size="20"
          :weight="TextWeight.bold"
          :spacing="-0.38"
        />
      </VBlock>
      <VBlock v-if="showRewardBaeminPointAmount" :sort="Sort.space_between">
        <VSpan text="적립예정포인트" :size="20" :weight="TextWeight.bold" :spacing="-0.38" />
        <VSpan
          :text="`${rewardBaeminPointAmount || 0}원`"
          :type="TextType.Number"
          :size="20"
          :weight="TextWeight.bold"
          :spacing="-0.38"
        />
      </VBlock>
    </VBlock>
  </VCard>
</template>

<script>
import VBullet from '../../atoms/VBullet'
import VBlock, { Direction, Sort } from '../../molecules/VBlock'
import VCard from '../../molecules/VCard'
import VSpan, { TextWeight, TextType, TextColor } from '../../atoms/VSpan'
import VHR from '../../atoms/VHR'

export default {
  name: 'OrderDetailPayment',
  components: { VSpan, VBlock, VBullet, VCard, VHR },
  props: {
    orderAmount: {
      type: Number
    },
    deliveryTip: {
      type: Number
    },
    discountAmount: {
      type: Number
    },
    baeminPoint: {
      type: Object,
      required: true
    },
    orderDetailDiscounts: {
      type: Array,
      required: true
    },
    orderDetailPayment: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      Direction,
      Sort,
      TextWeight,
      TextType,
      TextColor
    }
  },
  computed: {
    showDeliveryTip() {
      return !!this.deliveryTip
    },
    showDiscountAmount() {
      return !!this.discountAmount
    },
    showOrderDetailDiscounts() {
      return !!this.discountAmount
    },
    showBaeminPointDiscountAmount() {
      return !!this.baeminPointDiscountAmount
    },
    showBaeminGiftCardDiscountAmount() {
      return !!this.baeminGiftCardDiscountAmount
    },
    showPaymentMethod() {
      return (
        this.orderDetailPayment &&
        this.orderDetailPayment.amount &&
        this.orderDetailPayment.amount > 0
      )
    },
    showRewardBaeminPointAmount() {
      return !!this.rewardBaeminPointAmount
    },
    couponDiscountAmount() {
      return this.orderDetailDiscounts
        .filter(discount => discount.isDeliveryCouponType())
        .reduce((acc, cur) => acc + cur.amount, 0)
    },
    orderDiscountAmount() {
      return this.orderDetailDiscounts
        .filter(discount => discount.isProductCouponType())
        .reduce((acc, cur) => acc + cur.amount, 0)
    },
    baeminPointDiscountAmount() {
      return this.orderDetailDiscounts
        .filter(discount => discount.isBaeminPointType())
        .reduce((acc, cur) => acc + cur.amount, 0)
    },
    baeminGiftCardDiscountAmount() {
      return this.orderDetailDiscounts
        .filter(discount => discount.isBaeminGiftCardType())
        .reduce((acc, curr) => acc + curr.amount, 0)
    },
    rewardBaeminPointAmount() {
      return this.baeminPoint.expectedEarnAmount
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.detail-payment-wrapper {
  width: 100%;
  height: auto;
  border-bottom: 1px solid $light-gray-5;
  margin-bottom: 10px;

  .line {
    margin-top: 15px;
    margin-bottom: 25px;
    width: 100%;
    height: 1px;
    background-color: $gray-3;
  }

  .detail-discounts {
    position: relative;
    width: auto;

    .bullet {
      top: 7px;
    }

    .text {
      margin-left: 8px;
    }
  }
}
</style>
